/**
 * @file TabItemContext.ts
 * @author markJia(markjia@tencent.com)
 */
import React from 'react';
export var TabItemContext = React.createContext(null);